import { formatDuration } from '../../utils/validation';

interface BookingDetailsProps {
  pickupLocation: string;
  dropoffLocation: string;
  estimatedDuration: { car: number; bus: number } | null;
  pickupType?: string;
  pickupDate?: string;
  pickupTime?: string;
  paymentMethod?: string;
  timezone?: string;
}

export function BookingDetails({
  pickupLocation,
  dropoffLocation,
  estimatedDuration,
  pickupType,
  pickupDate,
  pickupTime,
  paymentMethod,
  timezone,
}: BookingDetailsProps) {
  
  // Format date into words if available
  const formattedDate = pickupDate ? formatDateInWords(pickupDate) : '';
  
  return (
    <div className="border rounded-lg p-4">
      <h3 className="font-semibold mb-2">Ride Details</h3>
      <div className="space-y-2">
        <p className="text-sm">
          <span className="text-gray-600">From:</span> {pickupLocation}
        </p>
        <p className="text-sm">
          <span className="text-gray-600">To:</span> {dropoffLocation}
        </p>
        {estimatedDuration && (
          <p className="text-sm">
            <span className="text-gray-600">Estimated Duration:</span>{' '}
            {formatDuration(estimatedDuration.car)}
          </p>
        )}        {pickupType && (
          <p className="text-sm">
            <span className="text-gray-600">Pickup Time:</span>{' '}
            {pickupType.charAt(0).toUpperCase() + pickupType.slice(1)}
            {pickupType === 'scheduled' && formattedDate && pickupTime ? (
              <>
                <br />
                {timezone && (
                  <>
                    <span className="ml-4 text-gray-600 text-xs">Timezone:</span>{' '}
                    <span className="text-blue-600 font-medium">{timezone}</span>
                    <br />
                  </>
                )}
                <span className="ml-4 text-gray-600 text-xs">Date:</span>{' '}
                <span className="font-medium">{formattedDate}</span>
                <br />
                <span className="ml-4 text-gray-600 text-xs">Time:</span>{' '}
                <span className="font-medium">{formatTime(pickupTime)}</span>
              </>
            ) : ''}
          </p>
        )}
        {paymentMethod && (
          <p className="text-sm">
            <span className="text-gray-600">Payment Method:</span>{' '}
            {paymentMethod}
          </p>
        )}
      </div>
    </div>
  );
}

// Format date string (YYYY-MM-DD) into words
function formatDateInWords(dateStr: string): string {
  try {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  } catch (error) {
    console.error('Error formatting date:', error);
    return dateStr; // Return original string if there's an error
  }
}

// Format time string (HH:MM) to add AM/PM
function formatTime(timeStr: string): string {
  try {
    // If the format is already HH:MM, parse it
    const [hours, minutes] = timeStr.split(':').map(Number);
    
    // Convert to 12-hour format
    const period = hours >= 12 ? 'PM' : 'AM';
    const hours12 = hours % 12 || 12; // Convert 0 to 12 for 12 AM
    
    return `${hours12}:${minutes.toString().padStart(2, '0')} ${period}`;
  } catch (error) {
    console.error('Error formatting time:', error);
    return timeStr; // Return original string if there's an error
  }
}